import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export interface ExportContentParams {
  showEditLevelTags?: boolean;
  showAccreditationTags?: boolean;
}

export const getIssuedManualContentPdf = async (
  id: string,
  contentId: string,
  contentType: string,
  exportParams?: ExportContentParams,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const queryParams = new URLSearchParams({
    manualContentType: contentType,
  });

  if (exportParams?.showEditLevelTags !== undefined) {
    queryParams.set('showEditLevelTags', exportParams.showEditLevelTags.toString());
  }
  if (exportParams?.showAccreditationTags !== undefined) {
    queryParams.set('showAccreditationTags', exportParams.showAccreditationTags.toString());
  }

  const url = `${baseApiUrl()}/lexipub/manuals/issued/v1/manuals/${id}/content/${contentId}/pdf?${queryParams.toString()}`;
  const data = await fetcher({
    method: 'get',
    url,
  }).catch((err) => {
    console.error('Error fetching issued manual:', err);
    if (onError) handleError(err, { onError });
    return null;
  });
  return data ? atob(data.pdfBase64) : null;
};
